<template>
    <v-speed-dial
            v-model="fab"
            direction="top"
            transition="slide-y-reverse-transition"
    >
        <template v-slot:activator>
            <v-tooltip left>
                <template v-slot:activator="{ on }">
                    <v-btn
                            v-model="fab"
                            color="accent"
                            dark
                            fab
                            v-on="on"
                    >
                        <v-icon v-if="fab">
                            mdi-close
                        </v-icon>
                        <v-icon v-else>
                            fas fa-draw-polygon
                        </v-icon>
                    </v-btn>
                </template>
                <span>Shapefile Einstellungen</span>
            </v-tooltip>
        </template>
        <v-tooltip left>
            <template v-slot:activator="{ on }">
                <v-btn
                        fab
                        dark
                        small
                        color="red"
                        v-on="on"
                        @click="removeLayer"
                >
                    <v-icon>mdi-delete</v-icon>
                </v-btn>
            </template>
            <span>Shapefiles entfernen</span>
        </v-tooltip>
        <v-tooltip left>
            <template v-slot:activator="{ on }">
                <v-btn
                        fab
                        dark
                        small
                        color="primary"
                        v-on="on"
                        @click="openUploadDialog"
                >
                    <v-icon>mdi-plus</v-icon>
                </v-btn>
            </template>
            <span>Shapefile hinzufügen</span>
        </v-tooltip>
    </v-speed-dial>
</template>

<script>
    import LeafletServices from "@/services/leaflet.service";

    export default {
        name: "MapButton",
        data() {
            return {
                fab: null,
            }
        },
        methods: {
            openUploadDialog: function () {
                this.$emit('openUploadDialog')
            },
            removeLayer: function () {
                LeafletServices.removeShapefile()
            }
        }
    }
</script>

<style scoped>

</style>